export default __webpack_public_path__ + "static/media/FAREEDA_UKKALI.0c148362.JPG";